// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"ChargeUpFast_thecomp__U0rbj"};